var commonRoot = "https://www.pinganwj.com";
var enterpage="";
var domainUrl = "http://eim.pingan.com.cn";
var businessType = "WJZS";
var param="";
var subbiztype = "WJZS|01";

var sidebar = {}
sidebar.webTalkOnline = function(width,height){
    var _urlAddr = disposeUrlAddr();
    var _enterpage =  getEnterPage();
    var _subbiztype = getSubBizType();
    var _storeId = getStoreId();
    var _businessType = businessType;
    var browserTpye = appInfo();
    var _param = param; //
    domainUrl = domainUrl.replace('https:', 'http:');
    var urlparam ="encryptStr=" + _param + "&businessType=" + _businessType + "&storeId=" + _storeId+ "&subbiztype=" + _subbiztype + "&browserTpye=" + browserTpye + "&enterpage=" + _enterpage + "&urlAddr=" + _urlAddr;
    if(width && height){
        window.open(domainUrl + '/web/webtalk?' + urlparam,'', 'height='+height+',width='+width+',titlebar=no,menubar=no,toolbar=no,location=no,directories=no,scrollbars=yes,status=no,resizable=yes,top=' + (screen.availHeight - height) / 2 + ',left=' + (screen.availWidth - width) / 2 + ';');
    }else{
        window.open(domainUrl + '/web/webtalk?' + urlparam,'', 'height=610,width=774,titlebar=no,menubar=no,toolbar=no,location=no,directories=no,scrollbars=yes,status=no,resizable=yes,top=' + (screen.availHeight - 612) / 2 + ',left=' + (screen.availWidth - 774) / 2 + ';');
    }
};

function getEnterPage() {
    if (typeof(enterpage)=='undefined') {
        return '';
    }
    return encodeURIComponent(enterpage);
}
function appInfo() {
    var Sys = {};
    var ua = navigator.userAgent.toLowerCase();
    var s;
    (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
        (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
            (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
                (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
                    (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
    var browserTpye = "";
    if (Sys.ie) {
        browserTpye = "msie" + "|" + Sys.ie
    };
    if (Sys.firefox) {
        browserTpye = "Firefox" + "|" + Sys.firefox
    };
    if (Sys.chrome) {
        browserTpye = "Chrome" + "|" + Sys.chrome
    };
    if (Sys.opera) {
        browserTpye = "Opera" + "|" + Sys.opera
    };
    if (Sys.safari) {
        browserTpye = "Safari" + "|" + Sys.safari
    };

    return browserTpye;
}

function getSubBizType() {
    if (typeof(subbiztype)=='undefined') {
        return '';
    }
    return subbiztype;
}

function getStoreId() {
    function webTalkOnline(width,height){
        var _urlAddr = disposeUrlAddr();
        var _enterpage =  getEnterPage();
        var _subbiztype = getSubBizType();
        var _storeId = getStoreId();
        var _businessType = businessType;
        var browserTpye = appInfo();
        var _param = param; //鍙傛暟鍖呮嫭鍔犲瘑涓插彿銆佷笟鍔＄被鍨�
        domainUrl = domainUrl.replace('https:', 'http:');
        var urlparam ="encryptStr=" + _param + "&businessType=" + _businessType + "&storeId=" + _storeId+ "&subbiztype=" + _subbiztype + "&browserTpye=" + browserTpye + "&enterpage=" + _enterpage + "&urlAddr=" + _urlAddr;
        if(width && height){
            window.open(domainUrl + '/web/webtalk?' + urlparam,'', 'height='+height+',width='+width+',titlebar=no,menubar=no,toolbar=no,location=no,directories=no,scrollbars=yes,status=no,resizable=yes,top=' + (screen.availHeight - height) / 2 + ',left=' + (screen.availWidth - width) / 2 + ';');
        }else{
            window.open(domainUrl + '/web/webtalk?' + urlparam,'', 'height=610,width=774,titlebar=no,menubar=no,toolbar=no,location=no,directories=no,scrollbars=yes,status=no,resizable=yes,top=' + (screen.availHeight - 612) / 2 + ',left=' + (screen.availWidth - 774) / 2 + ';');
        }
    }

    function getEnterPage() {
        if (typeof(enterpage)=='undefined') {
            return '';
        }
        return encodeURIComponent(enterpage);
    }
    function appInfo() {
        var Sys = {};
        var ua = navigator.userAgent.toLowerCase();
        var s;
        (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
            (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
                (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
                    (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
                        (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;
        var browserTpye = "";
        if (Sys.ie) {
            browserTpye = "msie" + "|" + Sys.ie
        };
        if (Sys.firefox) {
            browserTpye = "Firefox" + "|" + Sys.firefox
        };
        if (Sys.chrome) {
            browserTpye = "Chrome" + "|" + Sys.chrome
        };
        if (Sys.opera) {
            browserTpye = "Opera" + "|" + Sys.opera
        };
        if (Sys.safari) {
            browserTpye = "Safari" + "|" + Sys.safari
        };

        return browserTpye;
    }

    function getSubBizType() {
        if (typeof(subbiztype)=='undefined') {
            return '';
        }
        return subbiztype;
    }

    function getStoreId() {
        if (typeof(storeId)=='undefined') {
            return '';
        }
        return storeId;
    }

    function disposeUrlAddr(){
        var re =new RegExp("((http|ftp|https)://)(([a-zA-Z0-9\._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(/[a-zA-Z0-9\&%_\./-~-]*)?");
        var _urlAddr="";
        var _urlAddrStr=window.document.location.href;
        if(re.test(_urlAddrStr)){
            _urlAddr=encodeURIComponent(_urlAddrStr);
        }
        return _urlAddr;
    }

    if (typeof(storeId)=='undefined') {
        return '';
    }
    return storeId;
}

function disposeUrlAddr(){
    var re =new RegExp("((http|ftp|https)://)(([a-zA-Z0-9\._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(/[a-zA-Z0-9\&%_\./-~-]*)?");
    var _urlAddr="";
    var _urlAddrStr=window.document.location.href;
    if(re.test(_urlAddrStr)){
        _urlAddr=encodeURIComponent(_urlAddrStr);
    }
    return _urlAddr;
}

export default sidebar;


//////////////////
// WEBPACK FOOTER
// ./static/js/utils/kf_dialog.js
// module id = 2ikA
// module chunks = 1